import { ContextlessPoliciesEnum, ModulesEnum } from 'generated/resources/graphql'

import { Result } from '../handleMutation'

export type OneCreateAction = {
  actionResolver: OneCreationActionResolver
  policies?: ContextlessPoliciesEnum[]
  module?: ModulesEnum
}

export type NavigationResult = {
  to: string
  data: Record<string, unknown>
}

export const isNavigationResult = (result: unknown): result is NavigationResult => {
  return typeof result === 'object' && result !== null && 'to' in result && 'data' in result
}

export type OneCreationActionResolver = () => {
  resolver: (args: any, threadId: string) => Promise<NavigationResult | undefined | Result<unknown>>
  loading: boolean
}
